import { COMMANDS, KEY_NOTES, type CommandGroup } from '../../state/keymap';
import { Modal } from '../components/controls';

const GROUP_ORDER: CommandGroup[] = ['File', 'Edit', 'Image', 'Layer', 'Select', 'View', 'Tools'];

interface Row {
  keys: string;
  label: string;
}

/** Built from the keymap itself, so the dialog can never describe a stale binding. */
function rowsFor(group: CommandGroup): Row[] {
  return [
    ...COMMANDS.filter((command) => command.group === group).map((command) => ({
      keys: command.chords.join(' / '),
      label: command.label,
    })),
    ...KEY_NOTES.filter((note) => note.group === group).map((note) => ({
      keys: note.keys,
      label: note.label,
    })),
  ];
}

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      title="Keyboard Shortcuts"
      onClose={onClose}
      footer={
        <button type="button" className="button button--primary" onClick={onClose}>
          Close
        </button>
      }
    >
      {GROUP_ORDER.map((group) => (
        <div key={group} className="field field--stack">
          <strong>{group}</strong>
          <div className="shortcut-table">
            {rowsFor(group).map((row) => (
              <div key={row.keys} style={{ display: 'contents' }}>
                <span className="shortcut-table__key">{row.keys}</span>
                <span>{row.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </Modal>
  );
}
